export default __webpack_public_path__ + "static/media/GreenCircleTick.77769375.svg";